import gql from "graphql-tag";

export const GENERATE_TITLE = gql`
  mutation Mutation($input: GenerateKeywordTitleInput!) {
    generateKeywordTitle(input: $input)
  }
`;

export const GENERATE_PARAGRAPH = gql`
  mutation GenerateParagraph($input: GenerateParagraphInput!) {
    generateParagraph(input: $input)
  }
`;

export const GENERATE_HEADING = gql`
  mutation GenerateHeading($input: GenerateHeadingInput!) {
    generateHeading(input: $input)
  }
`;

export const GENERATE_BLOG = gql`
  mutation GenerateAiBlog($input: GenerateBlogInput!) {
    generateAiBlog(input: $input)
  }
`;
